import { type ChangeEvent, type KeyboardEvent, useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import AutogrowInput from "./AutogrowInput";

export default function InvisibleAutogrowInput({
    value,
    onChange,
    className,
}: {
    value: string;
    onChange: (value: string) => void;
    className?: string;
}) {
    const [inputValue, setInputValue] = useState(value);
    const [originalValue, setOriginalValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
        setOriginalValue(value);
    }, [value]);

    const persistChange = () => {
        if (inputValue !== originalValue) {
            onChange(inputValue);
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();

            e.currentTarget.blur(); // blur triggerst the saving on its turn
        } else if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            setInputValue(originalValue);
        }
    };

    const handleBlur = () => {
        persistChange();
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    return (
        <AutogrowInput
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            minWidth={1}
            inputClassName={cn(
                "border-none shadow-none bg-transparent hover:bg-zinc-200/50 focus:bg-white rounded-md px-2 py-1",
                "outline-none focus-visible:border-blue-500 focus-visible:ring-neutral-600 focus-visible:ring focus-visible:shadow-sm",
                className
            )}
            inputStyle={{
                boxSizing: "content-box",
            }}
        />
    );
}
